<template><!-- svgo-optimised -->
<svg class="icon icon__radiobutton-empty" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><rect height="7" stroke="#121212" width="7" x="4" y="4" rx="3.5"/></svg></template>